import {DeclarationEnumTypeLabel, TaxpayerTransitOrGapLabel} from '@entities/relations/constants';

import notFiledIcon from '@pages/Relations/assets/type/not-filed.svg';
import toDeductionIcon from '@pages/Relations/assets/type/to-deduction.svg';
import toPayIcon from '@pages/Relations/assets/type/to-pay.svg';
import zeroIcon from '@pages/Relations/assets/type/zero.svg';

export const getTaxpayerTypeLabelKey = (transitOrGap?: string) =>
    TaxpayerTransitOrGapLabel[transitOrGap || ''] || 'terms.taxpayer.no_tax';

export const getTaxpayerTypeKind = (transitOrGap?: string) => {
    switch (transitOrGap) {
        case 'GAP_SOURCE':
            return 'square';
        case 'TRANSIT_COMPANY':
            return 'triangle';
        case 'OTHER':
            return 'circle';
        default:
            return 'no-tax';
    }
};

export const getDeclarationTypeLabelKey = (declarationType?: string) =>
    DeclarationEnumTypeLabel[declarationType || ''];

export const getDeclarationTypeIcon = (declarationType?: string) => {
    switch (declarationType) {
        case 'PAYABLE':
            return toPayIcon;
        case 'DEDUCTION':
            return toDeductionIcon;
        case 'ZERO':
            return zeroIcon;
        case 'NOT_FILED':
        default:
            return notFiledIcon;
    }
};
